export function parseDateFromDatePicker(toDate: Date): string {
  return `${toDate.getDate()}-${(toDate.getMonth() + 1)}-${toDate.getFullYear()}`;
}
